import { TempActions } from '@mode/charts/domain';
import { reportEditActions } from '@mode/report-editor/domain';
import { SqlResultsRoot } from '@mode/legacy/types-app-state';
import { DEFAULT_FLAMINGO_PAGE_SIZE } from '@mode/shared/util-js';
import { combineAllReducers } from '@mode/legacy/util-domain';
import { SwitchViewActions } from '@mode/switch-views/contract';
import { ClientActionType } from '~/actions/client.actions';
import { Actions } from '../actions';
import { QueryActionType } from '../actions/query.actions';
import { ReportActionType } from '../actions/report-actions';
import { ReportRunActionType } from '../actions/report-run.actions';
import { SqlResultActions } from '../actions/sql-results.actions';

export const initialSqlResultsState: SqlResultsRoot = {
  sqlResults: {
    paging: {},
  },
};

function pagingReducer(state = initialSqlResultsState.sqlResults.paging, action: Actions | TempActions.Union) {
  switch (action.type) {
    case TempActions.Type.DestroyQuerySuccess: {
      const { [action.token]: _, ...nextPaging } = state; // destructure to remove a key
      return nextPaging;
    }
    case QueryActionType.BatchUpdateQueries:
      // handle remapping query tokens
      return action.payload
        .filter((q) => state[q.mapping_id] != null)
        .reduce(
          (acc, query) => ({
            ...state,
            [query.mapping_id]: undefined,
            [query.token]: state[query.mapping_id],
          }),
          state
        );
    case ClientActionType.LoadReportSuccess: // falls through
    case ReportActionType.InitQueryResultPagination: // falls through
    case SwitchViewActions.queryRawDatasetAngularJs.type: // falls through
    case reportEditActions.selectQuery.type: {
      let myQueryToken: string;
      switch (action.type) {
        case reportEditActions.selectQuery.type:
        case ReportActionType.InitQueryResultPagination:
          myQueryToken = action.token;
          break;
        case SwitchViewActions.queryRawDatasetAngularJs.type:
          myQueryToken = action.queryToken;
          break;
        default:
          return state;
      }
      if (state[myQueryToken] == null) {
        return {
          ...state,
          [myQueryToken]: {
            offset: 0,
            pageSize: DEFAULT_FLAMINGO_PAGE_SIZE,
          },
        };
      }
      break;
    }
    case SqlResultActions.Type.SetOffset: {
      if (state[action.token] != null) {
        const paging = state[action.token];
        return {
          ...state,
          [action.token]: {
            ...paging,
            offset: action.offset,
          },
        };
      }
      break;
    }
    case SqlResultActions.Type.SetPageSize:
      if (state[action.token] != null) {
        const paging = state[action.token];
        return {
          ...state,
          [action.token]: {
            ...paging,
            pageSize: action.pageSize,
          },
        };
      }
      break;
    case ReportRunActionType.ExecuteReportRun:
      // would be better if this run off of an action that's after a query is run, but there isn't
      // any available
      if (action.runningQueryToken != null) {
        return {
          ...state,
          [action.runningQueryToken]: {
            pageSize: DEFAULT_FLAMINGO_PAGE_SIZE,
            offset: 0,
          },
        };
      } else {
        let newState = {};
        for (const queryToken in state) {
          if (state.hasOwnProperty(queryToken)) {
            newState = {
              ...newState,
              [queryToken]: {
                offset: 0,
                pageSize: DEFAULT_FLAMINGO_PAGE_SIZE,
              },
            };
          }
        }

        return newState;
      }
  }

  return state;
}

export const sqlResultsReducers = {
  paging: pagingReducer,
};

export const sqlResultsFeatureReducers = combineAllReducers<SqlResultsRoot, keyof SqlResultsRoot, Actions>({
  sqlResults: sqlResultsReducers,
});
